import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import Home from './pages/Home';
import Productivity from './pages/Productivity';
import Services from './pages/Services';
import Staffing from './pages/Staffing';
import Strategic from './pages/Strategic';
import Contact from './pages/Contact';
import OurTeam from './pages/OurTeam';
import AspiringMinds from './pages/AspiringMinds';
import AboutUs from './pages/AboutUs';
import JobApplication from './pages/JobApplication';
import ORSACProject from './pages/ORSACProject';
import RedefiningProductivityProject from './pages/RedefiningProductivityProject';
import RevolutionizingSalesProject from './pages/RevolutionizingSalesProject';
import StrategicOverhaulProject from './pages/StrategicOverhaulProject';
import LeanTransformationProject from './pages/LeanTransformationProject';
import { useState, useEffect } from 'react';
import Loader from './Components/Loader';
import Indigis from './pages/Indigis';

function RoutesWithLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [location]);

  return loading ? (
    <Loader />
  ) : (
    <Routes location={location}>
      <Route path='/' element={<Home />} />
      <Route path='/overview' element={<AboutUs />} />
      <Route path='/productivity' element={<Productivity />} />
      <Route path='/indigis-enterprise' element={<Indigis />} />
      <Route path='/technology-services' element={<Services />} />
      <Route path='/stratrgic-HR' element={<Strategic />} />
      <Route path='/meet-our-team' element={<OurTeam />} />
      <Route path='/contact-us' element={<Contact />} />
      <Route path='/our-team' element={<OurTeam />} />
      <Route path='/aspiring-minds' element={<AspiringMinds />} />
      <Route path='/staffing' element={<Staffing />} />
      <Route path='/apply-now' element={<JobApplication />} />
      <Route path='/orsac-project' element={<ORSACProject />} />
      <Route path='/redefining-productivity-incentives' element={<RedefiningProductivityProject />} />
      <Route path='/revolutionizing-sales-operations' element={<RevolutionizingSalesProject />} />
      <Route path='/strategic-overhaul' element={<StrategicOverhaulProject />} />
      <Route path='/lean-transformation' element={<LeanTransformationProject />} />  
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <RoutesWithLoader />
    </BrowserRouter>
  );
}

export default App;
